import {
  CREATOR_REFERRALS_LOADED,
  CREATOR_REFERRALS_CLEAR,
  CREATOR_REFERRAL_INVITE_LINK_LOADED,
  CREATOR_REFERRAL_INVITE_LINK_CLEAR,
} from '../actionTypes';
import * as api from '../apiHelper';
import {
  setFetchLoaderLoading,
  setFetchLoaderReset,
  setSubmissionLoaderLoading,
  setSubmissionLoaderReset,
} from '../fetchLoaderActions';
import { arriveNotice } from '../noticeActions';

// --- Reducer corresponding actions ---
export function creatorReferralsLoaded(referrals) {
  return {
    type: CREATOR_REFERRALS_LOADED,
    payload: { referrals },
  };
}

export function creatorReferralsClear() {
  return { type: CREATOR_REFERRALS_CLEAR };
}

export function creatorReferralInviteLinkLoaded(inviteLink) {
  return {
    type: CREATOR_REFERRAL_INVITE_LINK_LOADED,
    payload: { inviteLink },
  };
}

export function creatorReferralInviteLinkClear() {
  return { type: CREATOR_REFERRAL_INVITE_LINK_CLEAR };
}

// --- API functions ---
async function fetchReferralsApi(token, dispatch) {
  const response = await api.get({
    path: 'common/creator-referrals',
    version: 'gateway',
    token,
    dispatch,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

async function fetchInviteLinkApi(token, dispatch) {
  const response = await api.get({
    path: 'common/creator-referrals/invite-link',
    version: 'gateway',
    token,
    dispatch,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

async function sendInviteApi(token, email, dispatch) {
  const response = await api.post({
    path: 'common/creator-referrals/send-invite',
    version: 'gateway',
    token,
    /* eslint-disable camelcase */
    body: { invited_email: email },
    /* eslint-enable camelcase */
    dispatch,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

export async function fetchReferralInfoApi(referralToken) {
  const response = await api.get({
    path: `common/creator-referrals/info?token=${encodeURIComponent(referralToken)}`,
    version: 'gateway',
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

export async function fetchReferralInviteByTokenAndEmailApi(referralToken, email) {
  const response = await api.get({
    path: `common/creator-referrals/by-token/${encodeURIComponent(referralToken)}?email=${encodeURIComponent(email)}`,
    version: 'gateway',
    customError: true,
  });
  if (!response.ok) {
    const json = await response.json();
    const error = new Error(json.message || 'Referral not found');
    error.statusCode = response.status;
    throw error;
  }
  const json = await response.json();
  return api.camelizeKeys(json);
}

// --- Public component actions ---
export function fetchCreatorReferrals() {
  return async (dispatch, getState) => {
    try {
      const { auth: { token }, fetchLoader: { dataLoading } } = getState();
      if (!dataLoading) dispatch(setFetchLoaderLoading());
      const data = await fetchReferralsApi(token, dispatch);
      dispatch(creatorReferralsLoaded(data.referrals || []));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setFetchLoaderReset());
    }
  };
}

export function clearCreatorReferrals() {
  return (dispatch) => {
    dispatch(creatorReferralsClear());
  };
}

export function fetchCreatorReferralInviteLink() {
  return async (dispatch, getState) => {
    try {
      const { auth: { token } } = getState();
      const data = await fetchInviteLinkApi(token, dispatch);
      dispatch(creatorReferralInviteLinkLoaded(data));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    }
  };
}

export function clearCreatorReferralInviteLink() {
  return (dispatch) => {
    dispatch(creatorReferralInviteLinkClear());
  };
}

export function sendCreatorReferralInvite(email, onSuccess) {
  return async (dispatch, getState) => {
    try {
      const { auth: { token }, fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());
      await sendInviteApi(token, email, dispatch);
      dispatch(arriveNotice('Invite sent successfully', 'ok'));
      if (onSuccess) onSuccess();
    } catch (e) {
      dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setSubmissionLoaderReset());
    }
  };
}

